
import { format, parse, formatDistanceToNow } from "date-fns";

/**
 * Converts a Date object to a consistent YYYY-MM-DD string format
 * that preserves the local date regardless of timezone
 */
export const fromLocalDate = (date: Date): string => {
  return format(date, 'yyyy-MM-dd');
};

/**
 * Parses a YYYY-MM-DD string into a Date object in the local timezone
 */
export const toLocalDate = (dateString: string): Date => {
  return parse(dateString, 'yyyy-MM-dd', new Date());
};

/**
 * Converts an array of Date objects to consistent YYYY-MM-DD strings
 */
export const datesArrayToStrings = (dates: Date[]): string[] => {
  return dates.map(date => fromLocalDate(date));
};

/**
 * Converts an array of YYYY-MM-DD strings to Date objects
 */
export const stringsArrayToDates = (dateStrings: string[]): Date[] => {
  return dateStrings.map(dateString => toLocalDate(dateString));
};

/**
 * Format a date to show human-readable time remaining (e.g., "2 days", "3 hours")
 */
export const getTimeRemaining = (date: Date | string): string => {
  const targetDate = typeof date === 'string' ? new Date(date) : date;
  return formatDistanceToNow(targetDate, { addSuffix: false });
};
